import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import { fetchProfile, saveProfile } from '@actions/settings-actions';
import SettingsForm from '@components/settings/settings-form';
import * as colors from '@constants/colors';
import { getUserAvatar } from '@utils/data-table/user';
import './settings.scss';

const CustomTextField = withStyles({
  root: {
    '& input': {
      color: colors.dotmapsBlack80
    },
    '& input.Mui-disabled': {
      color: colors.dotmapsBlack40
    },
    '& label.Mui-disabled': {
      color: colors.dotmapsBlack40
    },
    '& label.Mui-error': {
      color: colors.dotmapsError
    }
  }
})(TextField);

const Profile = () => {
  const dispatch = useDispatch();
  const data = useSelector(state => state.settings.user);
  const permissions = useSelector(state => state.dataTypes.permission);

  const layout = { title: 'Your profile' };

  const onMount = useCallback(() => {
    dispatch(fetchProfile());
  }, [dispatch]);

  const handleSave = useCallback(formData => {
    dispatch(saveProfile(formData));
  }, [dispatch]);

  const renderPreForm = formData => {
    const userAvatarIcon = getUserAvatar(formData, 'giant');
    return (
      <div data-testid="settings-profile-form-avatar" styleName="avatar">
        <div data-testid="settings-profile-form-icon" styleName="icon">
          {userAvatarIcon}
        </div>
        <div styleName="content">
          <div data-testid="settings-profile-form-name" styleName="name">
            {formData.name}
          </div>
          <div data-testid="settings-profile-form-status" styleName="status">
            {formData.is_active ? 'Active' : 'Inactive'}
          </div>
        </div>
      </div>
    );
  };

  const renderForm = ({ data: formData, onChange }) => (
    <div data-testid="settings-profile-form" styleName="form">
      <div styleName="row row-two-columns">
        <div styleName="col1">
          <CustomTextField
            fullWidth
            label="Name"
            value={formData.name}
            helperText=" "
            onChange={event => onChange('name', event.target.value)}
          />
        </div>
        <div styleName="col2">
          <CustomTextField
            fullWidth
            disabled
            label="Email"
            value={formData.email}
            helperText="To update your email you need to contact app admins."
          />
        </div>
      </div>
      <div styleName="row row-two-columns">
        <div styleName="col1">
          <CustomTextField
            fullWidth
            label="Phone number"
            value={formData.phone}
            helperText=" "
            onChange={event => onChange('phone', event.target.value)}
          />
        </div>
        <div styleName="col2">
          <CustomTextField
            fullWidth
            disabled
            label="Agency"
            value={formData.agency_name}
            helperText="To update your agency you need to contact app admins."
          />
        </div>
      </div>
      <div styleName="row row-two-columns">
        <CustomTextField
          fullWidth
          disabled
          label="Permission"
          value={formData.permission ? permissions[formData.permission].name : ''}
          helperText="To update your permission you need to contact app admins."
        />
      </div>
    </div>
  );

  return (
    <SettingsForm
      data={data}
      layout={layout}
      onMount={onMount}
      customHandleSave={handleSave}
      renderPreForm={renderPreForm}
      renderForm={renderForm}
    />
  );
};

export default Profile;
